import type { WidgetTargetKey } from "src/shared/util/src/layout";

/**
 * Maps public widget route ids to the shared layout `targetKey` values.
 */
export const WEB_WIDGET_TARGET_KEY_BY_ID = {
  "current-athlete": "current_athlete",
  "category-ranking": "current_category",
  "current-group": "current_group",
  lights: "referee_lights",
  timer: "timer",
} as const satisfies Record<string, WidgetTargetKey>;

/**
 * Widget route ids supported by the public web runtime.
 */
export type WebWidgetRouteId = keyof typeof WEB_WIDGET_TARGET_KEY_BY_ID;

/**
 * Checks whether a route widget id can be resolved to a shared layout target.
 *
 * @param value - Raw widget id read from the route.
 * @returns `true` when the widget id is supported by the runtime layout layer.
 */
export function isWebWidgetRouteId(value: string): value is WebWidgetRouteId {
  return value in WEB_WIDGET_TARGET_KEY_BY_ID;
}

/**
 * Returns the shared layout target key associated with a public widget route.
 *
 * @param widgetId - Public widget route id.
 * @returns The matching shared layout target key.
 */
export function widgetRouteIdToTargetKey(
  widgetId: WebWidgetRouteId,
): WidgetTargetKey {
  return WEB_WIDGET_TARGET_KEY_BY_ID[widgetId];
}
